import React from "react";
import "./index.scss";
import { HomePage } from "./Pages";
import { LangProvider } from "./i18n";

function App() {
  return (
    <LangProvider>
      <div className="App">
        <HomePage />
      </div>
    </LangProvider>
  );
}

export default App;
